module.exports = __webpack_public_path__ + "img/9788996762225.6a0f4088.jpg";